"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Conditional = void 0;

var tslib_1 = require("tslib");

var react_1 = tslib_1.__importDefault(require("react"));

var Conditional = function Conditional() {
  return react_1.default.createElement("path", {
    fill: "currentColor",
    d: "M24 17.203c-.014-1.852-1.272-3.427-2.989-3.74-1.717-.314-3.398.724-3.992 2.465h-1.415c-1.325 0-2.4-1.142-2.4-2.55a3.963 3.963 0 00-.935-2.552c-.678-.806-1.646-1.27-2.663-1.275H6.991c-.584-1.757-2.274-2.81-4.001-2.496C1.263 7.371 0 8.963 0 10.826c0 1.864 1.263 3.456 2.99 3.771 1.727.316 3.417-.738 4.001-2.495h2.615c.662 0 1.2.57 1.2 1.275 0 2.818 2.148 5.102 4.798 5.102h1.415c.594 1.74 2.275 2.779 3.992 2.465 1.717-.313 2.976-1.889 2.989-3.74zM14.126 9v-.354c0-1.224.982-2.216 2.192-2.216h1.294a3.284 3.284 0 003.656 2.168C22.846 8.324 24 6.94 24 5.323c0-1.618-1.154-3.001-2.732-3.275a3.284 3.284 0 00-3.656 2.167h-1.294c-2.15.006-3.98 1.587-4.318 3.733.78.182 1.507.542 2.126 1.052z"
  });
};

exports.Conditional = Conditional;